var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1458 10.3333C10.1458 11.9742 11.4842 13.3125 13.125 13.3125H17.25V14C17.25 15.8333 16.3333 16.75 14.5 16.75H3.5C1.66667 16.75 0.75 15.8333 0.75 14V2.08333C0.75 3.09167 1.575 3.91667 2.58333 3.91667H14.5C16.3333 3.91667 17.25 4.83333 17.25 6.66667V7.35417H13.125C11.4842 7.35417 10.1458 8.6925 10.1458 10.3333ZM13.125 8.72917C12.245 8.72917 11.5208 9.45333 11.5208 10.3333C11.5208 11.2133 12.245 11.9375 13.125 11.9375H17.25V8.72917H13.125ZM13.6017 11.25C13.0975 11.25 12.6758 10.8375 12.6758 10.3333C12.6758 9.82917 13.0883 9.41667 13.5925 9.41667H13.6017C14.1059 9.41667 14.5184 9.82917 14.5184 10.3333C14.5184 10.8375 14.1059 11.25 13.6017 11.25ZM11.75 0.25H3.27083C2.63833 0.25 2.125 0.763333 2.125 1.39583C2.125 2.02833 2.63833 2.54167 3.27083 2.54167H14.4725C14.335 1.01083 13.4275 0.25 11.75 0.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.f8d7609fd22df6c60ae3bb392515ea36.svg";
export { ForwardRef as ReactComponent };